export const styles = {
    top: {
        position: 'fixed',
        margin: '0px auto',
        top: 'calc(.625rem + env(safe-area-inset-top))',
        left: '50%',
        transform: ' translateX(-50%)',
    },
    'top-right': {
        position: 'fixed',
        top: 'calc(.625rem + env(safe-area-inset-top))',
        right: 'calc(.625rem + env(safe-area-inset-right))',
    },
    'top-left': {
        position: 'fixed',
        top: 'calc(.625rem + env(safe-area-inset-top))',
        left: 'calc(.625rem + env(safe-area-inset-left))',
    },
    bottom: {
        position: 'fixed',
        margin: '0px auto',
        bottom: 'calc(.625rem + env(safe-area-inset-bottom))',
        left: '50%',
        transform: ' translateX(-50%)',
    },
    'bottom-left': {
        position: 'fixed',
        bottom: 'calc(.625rem + env(safe-area-inset-bottom))',
        left: 'calc(.625rem + env(safe-area-inset-left))',
    },
    'bottom-right': {
        position: 'fixed',
        bottom: 'calc(.625rem + env(safe-area-inset-bottom))',
        right: 'calc(.625rem + env(safe-area-inset-right))',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9hc3Quc3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvdG9hc3QvVG9hc3Quc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9BLE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBVztJQUM1QixHQUFHLEVBQUU7UUFDSCxRQUFRLEVBQUUsT0FBTztRQUNqQixNQUFNLEVBQUUsVUFBVTtRQUNsQixHQUFHLEVBQUUsMENBQTBDO1FBQy9DLElBQUksRUFBRSxLQUFLO1FBQ1gsU0FBUyxFQUFFLG1CQUFtQjtLQUMvQjtJQUNELFdBQVcsRUFBRTtRQUNYLFFBQVEsRUFBRSxPQUFPO1FBQ2pCLEdBQUcsRUFBRSwwQ0FBMEM7UUFDL0MsS0FBSyxFQUFFLDRDQUE0QztLQUNwRDtJQUNELFVBQVUsRUFBRTtRQUNWLFFBQVEsRUFBRSxPQUFPO1FBQ2pCLEdBQUcsRUFBRSwwQ0FBMEM7UUFDL0MsSUFBSSxFQUFFLDJDQUEyQztLQUNsRDtJQUNELE1BQU0sRUFBRTtRQUNOLFFBQVEsRUFBRSxPQUFPO1FBQ2pCLE1BQU0sRUFBRSxVQUFVO1FBQ2xCLE1BQU0sRUFBRSw2Q0FBNkM7UUFDckQsSUFBSSxFQUFFLEtBQUs7UUFDWCxTQUFTLEVBQUUsbUJBQW1CO0tBQy9CO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsUUFBUSxFQUFFLE9BQU87UUFDakIsTUFBTSxFQUFFLDZDQUE2QztRQUNyRCxJQUFJLEVBQUUsMkNBQTJDO0tBQ2xEO0lBQ0QsY0FBYyxFQUFFO1FBQ2QsUUFBUSxFQUFFLE9BQU87UUFDakIsTUFBTSxFQUFFLDZDQUE2QztRQUNyRCxLQUFLLEVBQUUsNENBQTRDO0tBQ3BEO0NBQ0YsQ0FBQyJ9